export default `
div#root, div#cert-wrap {
  margin-top: var(--safe-area-inset-top);
}
`;
